export const openDrawerWidth = 240;
export const collapsedDrawerWidth = 70;